export const FILTER_MESSAGES = "messages_container_filter";
export const FILTER_ATTACHMENTS = "attachments_container_filter";
